module.exports = __webpack_public_path__ + "static/media/cq_info.473d78f4.svg";